// DonorFields.js
import React, { useState, useEffect } from 'react';
import { ErrorMessage, Field, useFormikContext } from 'formik';
import Autocomplete from '../Autocomplete';
import { DonorService } from '../../../Services/Donor.Service';
import { convertFieldResponseIntoMuiTextFieldProps } from '@mui/x-date-pickers/internals';
import { Dropdown } from "react-bootstrap";
import { SampleService } from '../../../Services/Sample.service';

const SpecialDonor = ({ selectedSampleIds, setSampleTypeError, donorType, setFieldValue, elementRef, specialDonor, setSpecialDonor, selectedDonorIds, setSelectedDonorIds, excludedDonorIds, sampleId, activeField, setActiveField, donorDemographicsDataFromDetails ,donorDemographicsDataFromDetailsUnmatched}) => {
  // console.log("sampleId",sampleId);

  const { values } = useFormikContext();
  const [sponsorErrors, setSponsorErrors] = useState({});
  const [disableInput, setDisableInput] = useState(false);
  // const [totalQuantity, setTotalQuantity] = useState(0);
  const combinedDonorIds = [...new Set([...selectedDonorIds, ...excludedDonorIds])];

  const [raceData, setRaceData] = useState([]); // Store race options from API
  const [singleHeritage, setSingleHeritage] = useState([]);
  const [dualHeritage, setDualHeritage] = useState([]);
  useEffect(() => {
    console.log("Unmatched:", donorDemographicsDataFromDetailsUnmatched);
  },[donorDemographicsDataFromDetailsUnmatched]);

  useEffect(() => {
    //  Use donorDemographicsDataFromDetails if available, else fallback to donorDemographicsDataFromDetailsUnmatched
    const sourceData =
      donorDemographicsDataFromDetails?.length > 0
        ? donorDemographicsDataFromDetails
        : donorDemographicsDataFromDetailsUnmatched?.length > 0
          ? donorDemographicsDataFromDetailsUnmatched
          : [];

    if (
      sourceData.length === 0 ||
      (!singleHeritage?.race_options && !dualHeritage?.race_options)
    ) return;

    //  Convert backend data → UI shape
    const converted = sourceData.map((item, index) => {
      const genderMap = { "XX": "Female", "XY": "Male" };
      const biologicalSex = genderMap[item.demographics_gender] || '';

      const raceIds = item.race_options ? JSON.parse(item.race_options) : [];

      let raceSingleHeritage = '';
      let raceDualHeritage = [];

      if (item.type_id === 1) {
        const raceObj = singleHeritage?.race_options?.find(r => raceIds.includes(r.race_id));
        raceSingleHeritage = raceObj ? { ...raceObj, type_id: 1 } : '';
      } else if (item.type_id === 2) {
        raceDualHeritage = dualHeritage?.race_options
          ?.filter(r => raceIds.includes(r.race_id))
          .map(r => ({ ...r, type_id: 2 })) || [];
      }

      return {
        id: index + 1,
        age_from: item.from_age,
        age_to: item.to_age,
        biologicalSex,
        raceDualHeritage,
        raceSingleHeritage,
        quantity: item.demographics_quantity ?? 0
      };
    });

    setSubmittedData(converted);

    //  Convert UI shape → backend shape
    const transformedData = converted.map(item => {
      const raceOptions = item.raceDualHeritage?.length > 0
        ? item.raceDualHeritage.map(r => r.race_id)
        : (item.raceSingleHeritage ? [item.raceSingleHeritage.race_id] : []);

      const typeId = item.raceDualHeritage?.length > 0 ? 2 : item.raceSingleHeritage ? 1 : null;

      const genderMap = { "Male": "XY", "Female": "XX" };
      const gender = genderMap[item.biologicalSex] || item.biologicalSex || null;

      return {
        from_age: item.age_from || null,
        to_age: item.age_to || null,
        quantity: item.quantity || null,
        gender,
        race_options: raceOptions?.length > 0 ? raceOptions : null,
        type_id: typeId
      };
    });

    //  Save to specialDonor + Formik field
    if (sampleId) {
      setSpecialDonor(prevSpecialDonor => {
        const donorData = prevSpecialDonor[sampleId]?.special_donor?.[`${donorType}_donor`] || { donor_ids: [] };
        return {
          ...prevSpecialDonor,
          [sampleId]: {
            ...prevSpecialDonor[sampleId],
            special_donor: {
              ...prevSpecialDonor[sampleId]?.special_donor,
              [`${donorType}_donor`]: {
                ...donorData,
                donorDemographicsData: transformedData
              }
            }
          }
        };
      });

      setFieldValue(`special_donor_donorDemographicsData_${sampleId}`, converted);
    } else {
      setSpecialDonor(prevSpecialDonor => {
        const donorData = prevSpecialDonor?.special_donor?.[`${donorType}_donor`] || { donor_ids: [] };
        return {
          ...prevSpecialDonor,
          special_donor: {
            ...prevSpecialDonor?.special_donor,
            [`${donorType}_donor`]: {
              ...donorData,
              donorDemographicsData: transformedData
            }
          }
        };
      });

      setFieldValue('special_donor_donorDemographicsData', converted);
    }
  }, [
    donorDemographicsDataFromDetails,
    donorDemographicsDataFromDetailsUnmatched,
    singleHeritage,
    dualHeritage
  ]);



  const getRaceOptions = async () => {

    const result = await SampleService.getRaceOptions();
    if (result.success) {

      console.log("race options retrived sucessfully");
      setRaceData(result.race_option);

      // Extract and set heritage types separately
      const single = result.race_option.find(option => option.type_id === 1);
      const dual = result.race_option.find(option => option.type_id === 2);

      console.log("single", single); console.log("dual", dual);


      // setSingleHeritage(single ? single.race_options.map(r => r.heritage_name) : []);
      // setDualHeritage(dual ? dual.race_options.map(r => r.heritage_name) : []);
      setSingleHeritage(single || []);
      setDualHeritage(dual || []);
    }
    else {
      console.log("failed while getting race options")
    }
  }
  useEffect(() => {
    getRaceOptions();
  }, [])
  const handleSampleValidation = () => {
    if (Object.keys(selectedSampleIds).length == 0) {
      setSampleTypeError('Please select at least one sample type.');
      if (elementRef.current) {
        elementRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }
  };

  // const fetchDonorTotalQuantity = async (donorQty, donorGender, params) => {

  //     const fetchedQty = specialDonor.special_donor[`${donorType}_donor`][`${donorGender}_qty`];
  //     const totalQty = parseInt(donorQty) + parseInt(fetchedQty);

  //     try {            
  //         const response = await DonorService.fetchDonorTotalQuantity(params);
  //         if(response.success) {

  //           setTotalQuantity(response.total_donors || 0);
  //           setSponsorErrors((prevErrors) => ({
  //             ...prevErrors,
  //             [`${donorType}_donor_quantity`]: totalQty > response.total_donors ? `Total ${donorGender} donor(s) available within system are ${response.total_donors}. Please select quantity less than ${response.total_donors} donor(s)` : ''
  //           }));

  //           if (totalQty <= response.total_donors) {
  //             handleSpecialDonorQty(); 
  //           }

  //           setFieldValue(`${donorType}_donor_quantity`, '');
  //           setFieldValue(`${donorType}_donor_gender`, '');

  //         } else {
  //           setTotalQuantity(0); 
  //           console.error("Error while fetching quantity available.");
  //         }

  //     } catch (error) {
  //         setTotalQuantity(0);            
  //         console.error("Error while fetching quantity available.", error);
  //     }
  // }

  const handleSubmit = async () => {

    //Check if Any Error - If Sample selected or not        
    handleSampleValidation();

    // Check if donor ID selected otherwise show error
    const donorValue = values[`${donorType}_donor`];
    if (!donorValue) {
      alert("Please select donor id");
      return
    }
    // Calculate the total quantity from submittedData
    const totalSubmittedQuantity = submittedData.reduce((acc, item) => acc + (item.quantity || 0), 0);
    if (!values.volunteers || values.volunteers == 0 || values.volunteers < (specialDonor.special_donor[`${donorType}_donor`]?.donor_ids.length) + totalSubmittedQuantity + 1) {
      alert("The newly added donor exceeds the requested and specified donor quantity.");
      return
    }
    setSponsorErrors((prevErrors) => ({
      ...prevErrors,
      [`${donorType}_donor`]: typeof donorValue !== 'undefined' ? '' : 'Please select donor Id',
    }));


    if (donorValue && disableInput) {
      setFieldValue(`${donorType}_donor`, '');
      handleSpecialDonorId(donorValue);
    }

    setDisableInput(false);
  };

  // const handleBiologicalSubmit = async () => {  

  //     //Check if Any Error - If Sample selected or not        
  //     handleSampleValidation();

  //     // Check if donor gender & quantity selected otherwise show error
  //     const donorQty = parseInt(values[`${donorType}_donor_quantity`], 10);
  //     const donorGender = values[`${donorType}_donor_gender`];



  //     setSponsorErrors((prevErrors) => ({
  //     ...prevErrors,
  //     [`${donorType}_donor_quantity`]: !donorQty || !Number.isInteger(donorQty) || donorQty <= 0 ? 'Please enter a positive integer value' : '',
  //     [`${donorType}_donor_gender`]: donorGender ? '' : 'Please select biological sex',
  //     }));


  //     if (donorQty && donorGender && !sponsorErrors[`${donorType}_donor_quantity`]) {

  //         const params = {  
  //           gender: donorGender == 'female' ? 'XX' : 'XY',
  //           sample_id: sampleId ? sampleId : (typeof selectedSampleIds != 'undefined' && Object.keys(selectedSampleIds).length > 0 ? Object.keys(selectedSampleIds) : []),
  //           is_matched: values['matched_sample'] == 'Yes' ? true : false,
  //           selected_donor_id: combinedDonorIds,
  //         }
  //         fetchDonorTotalQuantity(donorQty, donorGender, params);

  //     }  
  // };


  // const handleDecimalInputChange = (event) => {
  //   if (event.key === '.' || event.key ==="-"  || event.key ==="+" ) { //restricting . - + 
  //       event.preventDefault();
  //   }
  // }

  // const handleQuantityInputChange = (quantityValue) => {
  //   const donorQty = parseInt(quantityValue, 10);
  //   setSponsorErrors((prevErrors) => ({
  //     ...prevErrors,
  //     [`${donorType}_donor_quantity`]: !donorQty || !Number.isInteger(donorQty) || donorQty <= 0 ? 'Please enter a positive integer value' : '',        
  //   }));

  //   if(!sponsorErrors[`${donorType}_donor_quantity`]) {
  //     setFieldValue(`${donorType}_donor_quantity`, donorQty);
  //   }
  // };



  const handleRemoveDonor = (donorIdToRemove) => {
    if (sampleId) {

      setSpecialDonor((prevSpecialDonor) => {
        const updatedDonorIds = prevSpecialDonor[sampleId].special_donor[`${donorType}_donor`].donor_ids.filter(
          (donorId) => donorId !== donorIdToRemove
        );

        return {
          ...prevSpecialDonor,
          [sampleId]: {
            ...prevSpecialDonor[sampleId],
            special_donor: {
              ...prevSpecialDonor[sampleId].special_donor,
              [`${donorType}_donor`]: { ...prevSpecialDonor[sampleId].special_donor[`${donorType}_donor`], donor_ids: updatedDonorIds },
            },
          },
        };
      });

      setSelectedDonorIds((prevSelectedDonorIds) => {
        return {
          ...prevSelectedDonorIds,
          [sampleId]: { ...prevSelectedDonorIds[sampleId], selected_donor_ids: prevSelectedDonorIds[sampleId].selected_donor_ids.filter((id) => id !== donorIdToRemove) },
        };
      });

      const fieldName = `special_donors_${sampleId}`;
      const previousValues = values[fieldName] || [];
      const updatedValues = previousValues.filter(item => item !== `${donorType}-${donorIdToRemove}`);
      setFieldValue(fieldName, updatedValues);

    } else {

      setSpecialDonor((prevSpecialDonor) => ({
        ...prevSpecialDonor,
        special_donor: {
          ...prevSpecialDonor.special_donor,
          [`${donorType}_donor`]: {
            ...prevSpecialDonor.special_donor[`${donorType}_donor`],
            donor_ids: prevSpecialDonor.special_donor[`${donorType}_donor`].donor_ids.filter(
              (donorId) => donorId !== donorIdToRemove
            ),
          },
        },
      }));

      setSelectedDonorIds((prevSelectedDonorIds) => {
        return prevSelectedDonorIds.filter((id) => id !== donorIdToRemove);
      });

      setFieldValue('special_donors', values.special_donors.filter(donor => donor !== donorType + '-' + donorIdToRemove));

    }
    setDisableInput(false);
  };

  // const handleRemoveGender = (genderToRemove) => {

  //   if(sampleId) {
  //     setSpecialDonor((prevSpecialDonor) => ({
  //       ...prevSpecialDonor,
  //       [sampleId]: {
  //           ...prevSpecialDonor[sampleId],
  //           special_donor: {
  //               ...prevSpecialDonor[sampleId].special_donor,
  //               [`${donorType}_donor`]: {
  //                   ...prevSpecialDonor[sampleId].special_donor[`${donorType}_donor`],
  //                   gender: prevSpecialDonor[sampleId].special_donor[`${donorType}_donor`].gender.filter( (gender) => gender !== genderToRemove ),
  //                   female_qty: genderToRemove === 'female' ? 0 : prevSpecialDonor[sampleId].special_donor[`${donorType}_donor`].female_qty,
  //                   male_qty: genderToRemove === 'male' ? 0 : prevSpecialDonor[sampleId].special_donor[`${donorType}_donor`].male_qty,
  //               },
  //           },
  //       },
  //     }));

  //     const fieldName = `special_donors_${sampleId}`;
  //     const previousValues = values[fieldName] || [];
  //     const updatedValues = previousValues.filter(item => item !== `${donorType}-${genderToRemove}`);
  //     setFieldValue(fieldName, updatedValues);

  //   } else {
  //     setSpecialDonor((prevSpecialDonor) => ({
  //         ...prevSpecialDonor,
  //         special_donor: {
  //             ...prevSpecialDonor.special_donor,
  //             [`${donorType}_donor`]: {
  //                 ...prevSpecialDonor.special_donor[`${donorType}_donor`],
  //                 gender: prevSpecialDonor.special_donor[`${donorType}_donor`].gender.filter((gender) => gender !== genderToRemove),
  //                 female_qty: genderToRemove === 'female' ? 0 : prevSpecialDonor.special_donor[`${donorType}_donor`].female_qty,
  //                 male_qty: genderToRemove === 'male' ? 0 : prevSpecialDonor.special_donor[`${donorType}_donor`].male_qty,
  //             },
  //         },
  //     }));
  //     setFieldValue('special_donors', values.special_donors.filter(donor => donor !== donorType+'-'+genderToRemove));
  //   }

  // };
  useEffect(() => {
    console.log("specialDonor", specialDonor);
  }, [specialDonor]);
  const handleSpecialDonorId = (donorValue) => {
    if (sampleId) {

      setSpecialDonor((prevSpecialDonor) => {
        const donorData = prevSpecialDonor[sampleId].special_donor[`${donorType}_donor`] || { donor_ids: [] };
        const updatedDonorIds = donorData.donor_ids.includes(donorValue) ? donorData.donor_ids : [...donorData.donor_ids, donorValue];

        return {
          ...prevSpecialDonor,
          [sampleId]: {
            ...prevSpecialDonor[sampleId],
            special_donor: {
              ...prevSpecialDonor[sampleId].special_donor, [`${donorType}_donor`]: { ...donorData, donor_ids: updatedDonorIds }
            }
          }
        };
      });

      setSelectedDonorIds((prevSelectedDonorIds) => {
        if (!prevSelectedDonorIds[sampleId].selected_donor_ids.includes(donorValue)) {
          return {
            ...prevSelectedDonorIds,
            [sampleId]: { ...prevSelectedDonorIds[sampleId], selected_donor_ids: [...prevSelectedDonorIds[sampleId].selected_donor_ids, donorValue] }
          };
        }
        return prevSelectedDonorIds;
      });

      const fieldName = `special_donors_${sampleId}`;
      const previousValues = values[fieldName] || [];
      const updatedValues = [...previousValues, `${donorType}-${donorValue}`];
      setFieldValue(fieldName, updatedValues);


    } else {

      setSpecialDonor((prevSpecialDonor) => {
        const donorData = prevSpecialDonor.special_donor[`${donorType}_donor`] || { donor_ids: [] };
        const updatedDonorIds = donorData.donor_ids.includes(donorValue) ? donorData.donor_ids : [...donorData.donor_ids, donorValue];

        return {
          ...prevSpecialDonor,
          special_donor: { ...prevSpecialDonor.special_donor, [`${donorType}_donor`]: { ...donorData, donor_ids: updatedDonorIds } }
        };

      });

      setSelectedDonorIds((prevSelectedDonorIds) => {
        if (!prevSelectedDonorIds.includes(donorValue)) {
          return [...prevSelectedDonorIds, donorValue];
        }
        return prevSelectedDonorIds;
      });

      setFieldValue('special_donors', [...values.special_donors, donorType + '-' + donorValue]);

    }
  }

  // const handleSpecialDonorQty = () => {
  //   const selectedGender = values[`${donorType}_donor_gender`];
  //   const selectedQuantity = values[`${donorType}_donor_quantity`];

  //   if(sampleId) {
  //     setSpecialDonor((prevSpecialDonor) => {

  //       const donorData = prevSpecialDonor[sampleId].special_donor[`${donorType}_donor`] || { gender: [], female_qty: 0, male_qty: 0 };
  //       const selectedGender = values[`${donorType}_donor_gender`];
  //       const selectedQuantity = values[`${donorType}_donor_quantity`];

  //       let updatedFemaleQty = donorData.female_qty;
  //       let updatedMaleQty = donorData.male_qty;

  //       if (selectedGender === 'female') {
  //         updatedFemaleQty = donorData.female_qty + selectedQuantity;
  //       } else if (selectedGender === 'male') {
  //         updatedMaleQty = donorData.male_qty + selectedQuantity;
  //       }

  //       const updatedGender = donorData.gender.includes(selectedGender) ? donorData.gender : [...donorData.gender, selectedGender];

  //       return {
  //         ...prevSpecialDonor, 
  //         [sampleId]: {
  //             ...prevSpecialDonor[sampleId],
  //             special_donor: { 
  //               ...prevSpecialDonor[sampleId].special_donor, 
  //               [`${donorType}_donor`]: {...donorData, gender: updatedGender, female_qty: updatedFemaleQty, male_qty: updatedMaleQty }
  //             }
  //         }
  //       };

  //     });

  //     const fieldName = `special_donors_${sampleId}`;
  //     const previousValues = values[fieldName] || [];
  //     const updatedValues = [...previousValues, donorType+'-'+selectedGender];
  //     setFieldValue(fieldName, updatedValues);

  //   } else {
  //     setSpecialDonor((prevSpecialDonor) => {

  //       const donorData = prevSpecialDonor.special_donor[`${donorType}_donor`] || { gender: [], female_qty: 0, male_qty: 0 };

  //       let updatedFemaleQty = donorData.female_qty;
  //       let updatedMaleQty = donorData.male_qty;

  //       setFieldValue('special_donors', [...values.special_donors, donorType+'-'+selectedGender]);

  //       if (selectedGender === 'female') {
  //         updatedFemaleQty = donorData.female_qty + selectedQuantity;
  //       } else if (selectedGender === 'male') {
  //         updatedMaleQty = donorData.male_qty + selectedQuantity;
  //       }

  //       const updatedGender = donorData.gender.includes(selectedGender) ? donorData.gender : [...donorData.gender, selectedGender];

  //         return {
  //           ...prevSpecialDonor,
  //           special_donor: { 
  //             ...prevSpecialDonor.special_donor, [`${donorType}_donor`]: {...donorData, gender: updatedGender, female_qty: updatedFemaleQty, male_qty: updatedMaleQty }
  //           }
  //         };

  //     });
  //   }
  // }


  // Specify Donor Groups by Demographics
  const handleDecimalNumber = (event) => {
    if (event.key === '.' || event.key === "-" || event.key === "+") {
      event.preventDefault();
    }
  };

  const [demographicsData, setDemographicsData] = useState({
    age_from: 18,
    age_to: 65,
    biologicalSex: '',
    raceDualHeritage: [],
    raceSingleHeritage: '',
    quantity: null,
  });
  const [submittedData, setSubmittedData] = useState([]);
  useState(() => {
    console.log(submittedData)
  }, [submittedData]);
  const raceOptions = [
    "American Indian or Alaska Native",
    "Asian",
    "Black or African American",
    "Hispanic or Latino",
    "Middle Eastern or North African",
    "Native Hawaiian or Other Pacific Islander",
    "White or Caucasian",
  ];


  const handleCheckboxChange = (race) => {
    setDemographicsData((prev) => {
      const newRaces = prev.raceDualHeritage.includes(race)
        ? prev.raceDualHeritage.filter((r) => r !== race)
        : [...prev.raceDualHeritage, race];

      return { ...prev, raceDualHeritage: newRaces };
    });
  };
  const totalSubmittedQuantity = submittedData.reduce((acc, item) => acc + (item.quantity || 0), 0);

  const handleSubmitDemographicsData = () => {
    // Calculate the total quantity from submittedData
    console.log("submittedData", submittedData);
    const totalSubmittedQuantity = submittedData.reduce((acc, item) => acc + (item.quantity || 0), 0);

    if (!values.volunteers || values.volunteers == 0 || values.volunteers < totalSubmittedQuantity + (specialDonor.special_donor[`${donorType}_donor`]?.donor_ids.length) + (demographicsData.quantity || 1)) {
      alert("The newly added donor exceeds the requested and specified donor quantity.");
      // setDemographicsData({
      //   age_from: 18,
      //   age_to: 65,
      //   biologicalSex: "",
      //   raceDualHeritage: [],
      //   raceSingleHeritage: "",
      //   quantity: "",
      // });
      return
    }

    if (
      (demographicsData.age_from && !demographicsData.age_to) ||
      (!demographicsData.age_from && demographicsData.age_to)
    ) {
      alert("Both Age From and Age To are required.");
      return;
    }

    // Validate at least one field among Age, Biological Sex, or Race must be selected
    const isAgeValid = demographicsData.age_from && demographicsData.age_to;
    const isBiologicalSexValid = demographicsData.biologicalSex;
    const isRaceValid = demographicsData.raceDualHeritage?.length > 0 || demographicsData.raceSingleHeritage;
    console.log("demographicsData.raceDualHeritage", demographicsData.raceDualHeritage);
    if (!isAgeValid && !isBiologicalSexValid && !isRaceValid) {
      alert("Please select at least one from the Age, Biological Sex, or Race fields.");
      return;
    }

    // Validate Age From is less than Age To
    if (isAgeValid && demographicsData.age_from > demographicsData.age_to) {
      alert("Age From should be less than Age To.");
      return;
    }

    // Check if an entry with the same details already exists
    const existingEntryIndex = submittedData.findIndex((item) => {
      // Sort the raceDualHeritage arrays before comparing
      const sortedRaceDualHeritage = JSON.stringify(
        item.raceDualHeritage.sort((a, b) => a.race_id - b.race_id)
      );
      const sortedCurrentRaceDualHeritage = JSON.stringify(
        demographicsData.raceDualHeritage.sort((a, b) => a.race_id - b.race_id)
      );

      return (
        item.age_from === demographicsData.age_from &&
        item.age_to === demographicsData.age_to &&
        item.biologicalSex === demographicsData.biologicalSex &&
        sortedRaceDualHeritage === sortedCurrentRaceDualHeritage &&
        item.raceSingleHeritage === demographicsData.raceSingleHeritage
      );
    });


    let updatedSubmittedData = [...submittedData];

    if (existingEntryIndex !== -1) {
      // If the same entry exists, update the quantity
      updatedSubmittedData[existingEntryIndex].quantity += demographicsData.quantity || 1;
    } else {
      // Otherwise, add a new entry
      updatedSubmittedData.push({
        ...demographicsData,
        quantity: demographicsData.quantity || 1,
      });
    }
    console.log("updatedSubmittedData", updatedSubmittedData);

    const transformedData = updatedSubmittedData.map(item => {
      // If both raceDualHeritage and raceSingleHeritage are empty, keeping the entry with race_options and type_id set to null
      const raceOptions = item.raceDualHeritage?.length > 0
        ? item.raceDualHeritage.map(race => race.race_id)
        : (item.raceSingleHeritage ? [item.raceSingleHeritage.race_id] : []);

      const typeId = item.raceDualHeritage?.length > 0 ? 2 : item.raceSingleHeritage ? 1 : null;

      // Convert biologicalSex values
      const genderMap = { "Male": "XY", "Female": "XX" };
      const gender = genderMap[item.biologicalSex] || item.biologicalSex || null;

      // If both raceDualHeritage and raceSingleHeritage are empty, set race_options and type_id to null
      return {
        from_age: item.age_from || null,
        to_age: item.age_to || null,
        quantity: item.quantity || null,
        gender: gender,
        race_options: raceOptions?.length > 0 ? raceOptions : null,
        type_id: typeId
      };
    });

    console.log("Transformed Data:", transformedData);

    setSubmittedData(updatedSubmittedData);

    //save to specialDonor state

    if (sampleId) {
      setSpecialDonor((prevSpecialDonor) => {
        const donorData = prevSpecialDonor[sampleId].special_donor[`${donorType}_donor`] || { donor_ids: [] };

        return {
          ...prevSpecialDonor,
          [sampleId]: {
            ...prevSpecialDonor[sampleId],
            special_donor: {
              ...prevSpecialDonor[sampleId].special_donor, [`${donorType}_donor`]: { ...donorData, donorDemographicsData: transformedData }
            }
          }
        };
      });

      const fieldName = `special_donor_donorDemographicsData_${sampleId}`;
      const updatedValues = updatedSubmittedData;
      setFieldValue(fieldName, updatedValues);
    }
    else {
      setSpecialDonor((prevSpecialDonor) => {
        const donorData = prevSpecialDonor.special_donor[`${donorType}_donor`] || { donor_ids: [] };
        return {
          ...prevSpecialDonor,
          special_donor: { ...prevSpecialDonor.special_donor, [`${donorType}_donor`]: { ...donorData, donorDemographicsData: transformedData } }
        };
      });
      // Ensure values.special_donor_donorDemographicsData is always an array before spreading
      setFieldValue(
        'special_donor_donorDemographicsData',
        updatedSubmittedData
      );
    }
    //

    setDemographicsData({
      age_from: 18,
      age_to: 65,
      biologicalSex: "",
      raceDualHeritage: [],
      raceSingleHeritage: "",
      quantity: "",
    });
  };

  // const handleDeleteDemographic = (index) => {
  //   debugger
  //   // const updatedData = submittedData.filter((_, i) => i !== index);
  //   // setSubmittedData(updatedData);

  //   setSubmittedData((prevData) => {
  //     debugger
  //     const updatedData = prevData.filter((_, i) => i !== index);
  //     if (sampleId) {
  //       const fieldName = `special_donor_donorDemographicsData_${sampleId}`;
  //       const updatedValues = updatedData;
  //       setFieldValue(fieldName, updatedValues);
  //     }
  //     else {
  //       // Update Formik field with the new data after deletion
  //       setFieldValue('special_donor_donorDemographicsData', updatedData);
  //     }

  //     return updatedData;
  //   });
  // };
  const handleDeleteDemographic = (index) => {
    setSubmittedData((prevData) => {
      const updatedData = prevData.filter((_, i) => i !== index);
      // Transform the updated data
      const transformedData = updatedData.map(item => {
        const raceOptions = item.raceDualHeritage?.length > 0
          ? item.raceDualHeritage.map(race => race.race_id)
          : (item.raceSingleHeritage ? [item.raceSingleHeritage.race_id] : []);
  
        const typeId = item.raceDualHeritage?.length > 0 ? 2 : item.raceSingleHeritage ? 1 : null;
  
        const genderMap = { "Male": "XY", "Female": "XX" };
        const gender = genderMap[item.biologicalSex] || item.biologicalSex || null;
  
        return {
          from_age: item.age_from || null,
          to_age: item.age_to || null,
          quantity: item.quantity || null,
          gender: gender,
          race_options: raceOptions?.length > 0 ? raceOptions : null,
          type_id: typeId
        };
      });
  
      // Update specialDonor state
      if (sampleId) {
        setSpecialDonor((prevSpecialDonor) => {
          const donorData = prevSpecialDonor[sampleId]?.special_donor?.[`${donorType}_donor`] || { donor_ids: [] };
  
          return {
            ...prevSpecialDonor,
            [sampleId]: {
              ...prevSpecialDonor[sampleId],
              special_donor: {
                ...prevSpecialDonor[sampleId].special_donor,
                [`${donorType}_donor`]: { ...donorData, donorDemographicsData: transformedData }
              }
            }
          };
        });
  
        // Update Formik field
        const fieldName = `special_donor_donorDemographicsData_${sampleId}`;
        setFieldValue(fieldName, updatedData);
      } else {
        setSpecialDonor((prevSpecialDonor) => {
          const donorData = prevSpecialDonor.special_donor?.[`${donorType}_donor`] || { donor_ids: [] };
  
          return {
            ...prevSpecialDonor,
            special_donor: {
              ...prevSpecialDonor.special_donor,
              [`${donorType}_donor`]: { ...donorData, donorDemographicsData: transformedData }
            }
          };
        });
  
        // Update Formik field
        setFieldValue('special_donor_donorDemographicsData', updatedData);
      }
  
      return updatedData;
    });
  };
  

  return (
    <>
      <div className="row mt-4 align-items-center">
        {/* {values.volunteers} */}
        <div className="col-xl-5">
          <Autocomplete
            name={`${donorType}_donor`}
            label={donorType === 'preferred' ? 'Specifiy Donor ID' : 'If donor is unavailable, select alternate donor(s)'}
            placeholder="Type Here to search..."
            error={sponsorErrors[`${donorType}_donor`]}
            value={values[`${donorType}_donor`]}
            setFieldValue={setFieldValue}
            allowInputChange={false}
            disableInputChange={disableInput}
            setDisableInputChange={setDisableInput}
            selectedDonorIds={combinedDonorIds}
            sampleIds={sampleId ? sampleId : selectedSampleIds}
            isMatched={values['matched_sample'] == 'Yes' ? true : false}
            activeField={activeField}
            setActiveField={setActiveField}

            is_partof_parent_study={values.is_partof_parent_study}
            exclude_parent_study_donors={values.exclude_parent_study_donors}
            parent_study_id={values.parent_study_id}
          />
        </div>
        {/* <div className="col-xl-1 special-donor-or mt-4">Or</div>
        <div className="col-xl-3 special-donor-qty">
          <Field
              type="number"
              min="1"
              placeholder="Quantity"
              name={`${donorType}_donor_quantity`}
              className="form-control"
              onKeyDown={handleDecimalInputChange}
              onChange={(event) => handleQuantityInputChange(event.target.value)}
          />
          {sponsorErrors && sponsorErrors[`${donorType}_donor_quantity`] && (
            <div className="text-danger">{sponsorErrors[`${donorType}_donor_quantity`]}</div>
          )}
        </div>
        <div className="col-xl-3 special-donor-gender">
          <Field 
          as="select" 
          name={`${donorType}_donor_gender`}
          className="form-control"
          >
              <option value="">Select Biological Sex</option>
              {Object.entries({ female: 'XX', male: 'XY' }).map(([key, value]) => (
                <option key={key} value={key}>{key.toUpperCase()} ({value})</option>
              ))}                                                                         
          </Field>             
          {sponsorErrors && sponsorErrors[`${donorType}_donor_gender`] && (
            <div className="text-danger">{sponsorErrors[`${donorType}_donor_gender`]}</div>
          )}
        </div> */}
      </div>
      <div className="row mt-4">
        <div className="col-xl-5">
          <button className="el-main-button mb-4" type="button" onClick={handleSubmit}>
            <i className="jj-btn-primary-ico"></i><span>{donorType === 'preferred' ? 'Add to Request' : 'Alternate Donor ID'}</span>
          </button>
        </div>
        <div className="col-xl-1"></div>
        {/* <div className="col-xl-6">
          <button className="el-main-button mb-4" type="button" onClick={handleBiologicalSubmit}>
            <i className="jj-btn-primary-ico"></i><span> Donor Biological Sex</span>
          </button>
        </div> */}
      </div>

      <div className="row mt-1 mb-1">
        <div className='col-xl-5'>
          {specialDonor.special_donor[`${donorType}_donor`]?.donor_ids?.length > 0 && (
            <>
              <label>Selected Donor IDs</label>
            </>
          )}
          {specialDonor.special_donor[`${donorType}_donor`]?.donor_ids?.map((donorId, index) => {
            return (
              <React.Fragment key={`${donorType}_donor_${donorId}`}>
                <div className="row mb-2">
                  <div className="col-xl-6">
                    <strong>Donor:</strong> {donorId}
                  </div>
                  <div className="col-xl-6 text-end">
                    <i className="el-icon-trash" onClick={() => handleRemoveDonor(donorId)}></i>
                  </div>
                </div>
              </React.Fragment>
            )
          })}

          {/* {specialDonor.special_donor[`${donorType}_donor`]?.gender?.map((gender, index) => (
            <React.Fragment key={`${donorType}_donor_${gender}`}>
              <div className="row mb-2">
                <div className="col-xl-6">
                  <strong>Donor:</strong> {gender.charAt(0).toUpperCase() + gender.slice(1)} ({specialDonor.special_donor[`${donorType}_donor`]?.[`${gender}_qty`]})
                </div>
                <div className="col-xl-6 text-end">
                  <i className="el-icon-trash" onClick={() => handleRemoveGender(gender)}></i>
                </div>                  
              </div>
            </React.Fragment>
          ))} */}
        </div>
      </div>
      <h5>Specify Donor Groups by Demographics</h5>
      <div className="row">
        <div className="col-xl-12 mb-4 mb-xl-0">
          <div className="row">
            <div className="col-xl-6 mb-4 mb-xl-0">
              <label htmlFor="age_from" className="form-label">Age Range From</label>
              <input
                type="number"
                min="18"
                max="65"
                placeholder="Type here"
                value={demographicsData.age_from}
                onBlur={(e) => {
                  if (e.target.value != "" && (Number(e.target.value) < 18 || Number(e.target.value) > 65)) {
                    alert("Age should be or between 18 to 65");
                  }
                }}
                onChange={(e) => {
                  if (e.target.value) {
                    setDemographicsData((prev) => ({ ...prev, age_from: Number(e.target.value) }))
                  }
                  else {
                    setDemographicsData((prev) => ({ ...prev, age_from: "" }))
                  }
                }}
                name="age_from"
                className="form-control"
                onKeyDown={handleDecimalNumber}
                autoComplete="off"
              />
            </div>
            <div className="col-xl-6 mb-4 mb-xl-0">
              <label htmlFor="age_to" className="form-label">To</label>
              <input
                type="number"
                min="18"
                max="65"
                placeholder="Type here"
                value={demographicsData.age_to}
                onBlur={(e) => {
                  if (e.target.value != "" && (Number(e.target.value) < 18 || Number(e.target.value) > 65)) {
                    alert("Age should be or between 18 to 65");
                  }
                }}
                onChange={(e) => {
                  if (e.target.value) {
                    setDemographicsData((prev) => ({ ...prev, age_to: Number(e.target.value) }))
                  } else {
                    setDemographicsData((prev) => ({ ...prev, age_to: "" }))
                  }
                }}
                name="age_to"
                className="form-control"
                onKeyDown={handleDecimalNumber}
                autoComplete="off"
              />
            </div>
          </div>
          <div className="col-xl-3 special-donor-gender job-list-st-filter el-board-table ">
            <Dropdown className="d-inline-block form-control dateRanegeFilter">
              <Dropdown.Toggle className="p-0" id="statusFilterDropdown">{demographicsData.biologicalSex ? `${demographicsData.biologicalSex.toUpperCase()} (${demographicsData.biologicalSex === "Male" ? "XY" : "XX"})` : "Biological Sex"}</Dropdown.Toggle>
              <Dropdown.Menu>
                {Object.entries({ Female: "XX", Male: "XY" }).map(([key, value]) => (
                  <Dropdown.Item
                    key={key}
                    active={demographicsData.biologicalSex === key}
                    onClick={() => setDemographicsData((prev) => ({ ...prev, biologicalSex: key }))}
                  >
                    {key.toUpperCase()} ({value})
                  </Dropdown.Item>
                ))}
                <Dropdown.Divider />
                <Dropdown.Item className="btn btn-link text-danger" onClick={() => setDemographicsData((prev) => ({ ...prev, biologicalSex: "" }))}>
                  Clear Selection
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            {/* <Field
                  as="select"
                  name={`demographicsGender`}
                  className="form-control"
                  value={demographicsData.biologicalSex}
                  onChange={(e) => {
                    setDemographicsData((prev)=>({...prev, biologicalSex :e.target.value }));
                  
                  }}
                >
                  <option value="">Select Biological Sex</option>
                  {Object.entries({ Female: 'XX', Male: 'XY' }).map(([key, value]) => (
                    <option key={key} value={key}>{key.toUpperCase()} ({value})</option>
                  ))}
                </Field> */}
          </div>
          <div className="col-xl-12 special-donor-gender">
            <div className='row'>
              <h5>Race</h5>
              <div className="col-6 mb-4 mb-xl-0">
                <h6 className="form-label">{dualHeritage.type_name}</h6>
                <p>{dualHeritage.type_description}</p>
                {dualHeritage?.race_options?.map((race) => (
                  <div key={race.race_id} className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      value={race}
                      id={`dual_heritage_${race.race_id}`} 
                      checked={demographicsData.raceDualHeritage.includes(race)}
                      onChange={() => {
                        setDemographicsData((prev) => ({ ...prev, raceSingleHeritage: '' }));
                        handleCheckboxChange(race);
                      }}
                    />
                    <label htmlFor={`dual_heritage_${race.race_id}`}  className="form-check-label">{race.heritage_name}</label>
                  </div>
                ))}
              </div>
              <div className="col-6 mb-4 mb-xl-0">
                <h6 className="form-label">{singleHeritage.type_name}</h6>
                <p>{singleHeritage.type_description}</p>
                {singleHeritage?.race_options?.map((race) => (
                  <div key={race.race_id} className="form-check">
                    <input
                      id={`single_heritage_${race.race_id}`} 
                      type="radio"
                      name="raceSingleHeritage"
                      value={race}
                      checked={demographicsData.raceSingleHeritage.heritage_name === race.heritage_name}
                      onChange={(e) => {
                        setDemographicsData((prev) => ({
                          ...prev,
                          raceDualHeritage: [],
                          raceSingleHeritage: race
                        }));
                      }}
                      className="form-check-input"
                    />
                    <label htmlFor={`single_heritage_${race.race_id}`}   className="ms-3 form-check-label">{race.heritage_name}</label>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-xl-6 mb-4 mb-xl-0">
            <label htmlFor="quantity" className="form-label">Quantity</label>
            <input
              type="number"
              name="quantity"
              min="0"
              className="form-control"
              placeholder="Type here"
              onKeyDown={handleDecimalNumber}
              value={demographicsData.quantity === null ? "" : demographicsData.quantity}
              autoComplete="off"
              onChange={(e) => {
                const numValue = e.target.value === "" ? "" : Number(e.target.value);
                setDemographicsData((prev) => ({ ...prev, quantity: numValue }));
              }}
            />
          </div>
          <button className="el-main-button mt-4" type="button" onClick={() => { handleSubmitDemographicsData() }}>
            <span>Add to Request</span>
          </button>
          <div className="col-xl-12 mt-4">
            {submittedData?.length > 0 && (<>
              <h5 className='mb-3'>Specified by Demographics</h5>
              <ul className="list-group">
                {submittedData.map((data, index) => (
                  <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                    <span>
                      {data.quantity}{data.biologicalSex ? `, ${data.biologicalSex} ${data.biologicalSex == "Male" ? "(XY)" : "(XX)"}` : ''}, {data.age_from || 0}-{data.age_to || 0}
                      {data.raceDualHeritage?.length > 0
                        ? `, ${data.raceDualHeritage.map(race => race.heritage_name).join(", ")}`
                        : ""}
                      {data.raceSingleHeritage ? `, ${data.raceSingleHeritage.heritage_name}` : ""}
                    </span>
                    <i className="el-icon-trash text-danger" onClick={() => handleDeleteDemographic(index)} style={{ cursor: "pointer" }}></i>
                  </li>
                ))}
              </ul>
            </>)}
          </div>
          <div className="col-xl-12 mt-4">
            {(specialDonor.special_donor[`${donorType}_donor`]?.donor_ids?.length > 0 || totalSubmittedQuantity > 0) && (<>
              <h5 className='mb-3'>Total Specified Donors</h5>
              <p>{values.volunteers} Donors requested</p>
              <p>{totalSubmittedQuantity + (specialDonor.special_donor[`${donorType}_donor`]?.donor_ids?.length)} Donors specified</p>
              <p>{values.volunteers - (totalSubmittedQuantity + (specialDonor.special_donor[`${donorType}_donor`]?.donor_ids?.length))} Donors still need to be specified by Donor ID or Demographics</p>
            </>)}
          </div>
        </div>
      </div>
    </>
  );
};

export default SpecialDonor;